import React from "react";
import { Modal, Button } from "antd";
import {
  CheckCircleOutlined,
  PrinterOutlined,
  MailOutlined,
} from "@ant-design/icons";

const AgreementSuccessModal = ({
  visible,
  onNext,
  onPrint,
  onSendMail,
  onClose,
}) => {
  return (
    <Modal
      title="Success"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button
          key="print"
          type="primary"
          icon={<PrinterOutlined />}
          onClick={onPrint}
        >
          Print
        </Button>,
        <Button key="mail" icon={<MailOutlined />} onClick={onSendMail}>
          Send to Mail
        </Button>,
        <Button key="close" onClick={onNext}>
          Next
        </Button>,
      ]}
    >
      <div style={{ textAlign: "center", padding: "5px 0" }}>
        <CheckCircleOutlined style={{ fontSize: 48, color: "green" }} />
        <div style={{ marginTop: 16, fontSize: 16, fontWeight: 500 }}>
          Quotation added successfully!
        </div>
      </div>
    </Modal>
  );
};

export default AgreementSuccessModal;
